<template>
	<h1 class="text-2xl font-semibold"><slot/></h1>
</template>
<script setup lang="ts"></script>